module.exports = __webpack_public_path__ + "img/retrospect-81-mobile.70b520ea.jpg";